class NumServices {
  constructor(view, reprintNumServicesEl, podcastNumServicesEl) {
    this.view = view;

    this.reprintNumServicesEl = reprintNumServicesEl;
    this.podcastNumServicesEl = podcastNumServicesEl;

    this.configureElements();
    this.bindElements();
    this.toggleServicesBasedOnLicenseAndSongType();
  }

  configureElements() {
    this.reprintNumServicesEl.select2nonUnique({
      placeholder: 'Number of services',
      minimumResultsForSearch: Infinity
    });

    this.podcastNumServicesEl.select2nonUnique({
      placeholder: 'Number of services',
      minimumResultsForSearch: Infinity
    });
  }

  bindElements() {
    const view = this.view;

    view.bind(this.podcastNumServicesEl, 'change.select2', (e) => {
      this.changePodcastNumServices(e);
    }).change();

    view.bind(this.reprintNumServicesEl, 'change.select2', (e) => {
      this.changeReprintNumServices(e);
    }).change();
  }

  onLicenseSelect(e) {
    this.toggleServicesBasedOnLicenseAndSongType();
  }

  changeReprintNumServices() {
    this.ensureNotZeroNumServices(this.reprintNumServicesEl, this.podcastNumServicesEl);
  }

  changePodcastNumServices() {
    this.ensureNotZeroNumServices(this.podcastNumServicesEl, this.reprintNumServicesEl);
  }

  ensureNotZeroNumServices(currentEl, otherEl) {
    if (!parseInt(currentEl.val()) && !parseInt(otherEl.val())) {
      if (otherEl.prop('disabled')) {
        currentEl.val(1).change();
      } else {
        otherEl.val(1).change();
      }
    }

    if (!this.view.submitAndStayEl || !this.view.submitAndViewEl) return;

    if (!parseInt(currentEl.val()) && !parseInt(otherEl.val())) {
      this.view.submitAndStayEl.prop('disabled', true);
      this.view.submitAndViewEl.prop('disabled', true);
    } else {
      this.view.submitAndStayEl.prop('disabled', false);
      this.view.submitAndViewEl.prop('disabled', false);
    }
  }

  static toggleServicesElements(reprint, podcast, reprintServicesEl, podcastServicesEl) {
    const reprintAndPodcast = reprint && podcast;
    const reprintServices = reprintServicesEl.parent().parent().find('.reprint-services');
    const podcastServices = podcastServicesEl.parent().parent().find('.podcast-services');
    const reprintServicesEmptyOption = reprintServicesEl.find('option[value="0"]');
    const podcastServicesEmptyOption = podcastServicesEl.find('option[value="0"]');

    reprintServices.removeClass('reprint-podcast reprint podcast');
    podcastServices.removeClass('reprint-podcast reprint podcast');

    reprintServicesEmptyOption.prop('disabled', reprint && !reprintAndPodcast);
    podcastServicesEmptyOption.prop('disabled', podcast && !reprintAndPodcast);

    if (reprint && podcast) {
      reprintServices.addClass('reprint-podcast');
      podcastServices.addClass('reprint-podcast');
    } else if (reprint) {
      podcastServicesEl.val(0).change();
      reprintServices.addClass('reprint');
      podcastServices.addClass('reprint');
    } else {
      reprintServicesEl.val(0).change();
      reprintServices.addClass('podcast');
      podcastServices.addClass('podcast');
    }
  }

  toggleServices(reprint, podcast) {
    this.constructor.toggleServicesElements(
      reprint,
      podcast,
      this.reprintNumServicesEl,
      this.podcastNumServicesEl
    );
  }

  toggleServicesBasedOnLicenseAndSongType() {
    let podcast;
    let reprint;

    const licenseTypeData = this.getLicenseReprintAndPodcast();
    const buttonData = this.getButtonLicenseAndPodcast();

    if (licenseTypeData) {
      podcast = licenseTypeData.podcast;
      reprint = licenseTypeData.reprint;
    }

    if (buttonData) {
      if (typeof podcast !== 'undefined') {
        podcast = podcast && buttonData.podcast;
      } else {
        podcast = buttonData.podcast;
      }

      if (typeof reprint !== 'undefined') {
        reprint = reprint && buttonData.reprint;
      } else {
        reprint = buttonData.reprint;
      }
    }

    this.toggleServices(reprint, podcast);
  }

  getLicenseReprintAndPodcast() {
    let reprint;
    let podcast;

    if (typeof this.view.licenseTypeSelect !== 'undefined') {
      const selectedOption = this.view.licenseTypeSelect.find('option:selected');

      reprint = selectedOption.data('is-reprint');
      podcast = selectedOption.data('is-podcast');

      return { reprint, podcast };
    }

    return false;
  }

  getButtonLicenseAndPodcast() {
    let reprint;
    let podcast;

    if (
      typeof this.view.buttonData !== 'undefined'
      && ('reprint' in this.view.buttonData)
      && ('podcast' in this.view.buttonData)
    ) {
      reprint = this.view.buttonData.reprint;
      podcast = this.view.buttonData.podcast;

      return { reprint, podcast };
    }

    return false;
  }

  static updateNumServicesLabels(currentBtn, reprintNumServices, podcastNumServices) {
    const currentRow = currentBtn.parent().parent();
    const infoPodcastServices = currentRow.find('.info_podcast_services');
    const infoReprintServices = currentRow.find('.info_reprint_services');
    const servicesLabel = currentRow.find('.services_label');
    const divider = currentRow.find('.divider');

    if (reprintNumServices > 0) {
      infoReprintServices.parent().show();
      infoReprintServices.html(reprintNumServices);
    } else {
      infoReprintServices.parent().hide();
    }

    if (podcastNumServices > 0) {
      infoPodcastServices.parent().show();
      infoPodcastServices.html(podcastNumServices);
    } else {
      infoPodcastServices.parent().hide();
    }

    if (reprintNumServices > 0 && podcastNumServices > 0) {
      divider.show();
    } else {
      divider.hide();
    }

    servicesLabel.html(reprintNumServices > 1 || podcastNumServices > 1 || (reprintNumServices > 0 && podcastNumServices > 0) ? ' services' : ' service');

    currentBtn.data('reprint-num-services', reprintNumServices);
    currentBtn.data('podcast-num-services', podcastNumServices);
  }
}

module.exports = NumServices;
